import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=479ebd76&scoped=true&"
import script from "./clause.vue?vue&type=script&lang=js&"
export * from "./clause.vue?vue&type=script&lang=js&"
import style0 from "./clause.vue?vue&type=style&index=0&id=479ebd76&lang=less&scoped=true&"
import style1 from "./clause.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ebd76",
  null
  
)

export default component.exports